import { AuthMockApi } from 'app/mock-api/common/auth/api';
import { UserMockApi } from 'app/mock-api/common/user/api';

export const mockApiServices = [
    AuthMockApi,
    UserMockApi,
];
